module.exports = __webpack_public_path__ + "static/media/cantonese_vocabulary_table_3.0d8a2b52.png";